import { mutationTypes } from '@/store/types';

const state = {
  map: null,
  overlays: [],
  markerData: [],
  markers: [],
  dirty: false,
};

const getters = {
};

const actions = {
};

const mutations = {
  [mutationTypes.googlemap.setMap](state, payload) {
    state.map = payload;
  },

  [mutationTypes.googlemap.setOverlays](state, payload) {
    state.overlays = payload;
  },

  [mutationTypes.googlemap.addOverlay](state, payload) {
    state.overlays.push(payload);
  },

  [mutationTypes.googlemap.editOverlay](state, payload) {
    state.overlays.splice(payload.index, 1, payload.overlay);
  },

  [mutationTypes.googlemap.removeOverlay](state, payload) {
    state.overlays.splice(payload.index, 1);
  },

  [mutationTypes.googlemap.setMarkerData](state, payload) {
    state.markerData = payload;
  },

  [mutationTypes.googlemap.setMarkers](state, payload) {
    state.markers = payload;
  },

  [mutationTypes.googlemap.addMarker](state, payload) {
    state.markers.push(payload);
  },

  [mutationTypes.googlemap.editMarker](state, payload) {
    state.markers.splice(payload.index, 1, payload.overlay);
  },

  [mutationTypes.googlemap.removeMarker](state, payload) {
    state.markers.splice(payload.index, 1);
  },

  [mutationTypes.googlemap.setDirty](state, payload) {
    state.dirty = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/googlemap.js